import { render, staticRenderFns } from "./bsgTable.vue?vue&type=template&id=38eb3f32&scoped=true"
import script from "./bsgTable.vue?vue&type=script&lang=js"
export * from "./bsgTable.vue?vue&type=script&lang=js"
import style0 from "./bsgTable.vue?vue&type=style&index=0&id=38eb3f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb3f32",
  null
  
)

export default component.exports